import { useContext } from 'react';
import { ContexteMarqueReact, type ContexteMarque } from './contexte';
import { NOM_AVANT_CHARGEMENT } from './marque';
import { NUANCES_AVANT_CHARGEMENT } from './nuances-avant-chargement';

/** Hors du fournisseur (écran rendu seul, en test) : la charte, sans aperçu. */
const SANS_FOURNISSEUR: ContexteMarque = {
  marque: { nom: NOM_AVANT_CHARGEMENT, nuances: NUANCES_AVANT_CHARGEMENT, logo: null },
  apercu: null,
  demarrerApercu: () => undefined,
  arreterApercu: () => undefined,
};

export function useMarque(): ContexteMarque {
  return useContext(ContexteMarqueReact) ?? SANS_FOURNISSEUR;
}
